import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import {
  Box,
  Breadcrumbs,
  CardMedia,
  Divider,
  Drawer,
  FormControl,
  Hidden,
  InputLabel,
  Link,
  List,
  ListItemButton,
  ListItemText,
  MenuItem,
  Paper,
  Select,
  Stack,
  Theme,
  Typography,
  useTheme,
} from '@mui/material';
import { Location } from 'history';
import { useEffect, useState } from 'react';
import { CommonLayout, CommonLayoutForInvestor } from '../commonComponents';
import { Redirect, Route, Switch, useHistory, useRouteMatch, Router } from 'react-router-dom';
import { AnimatedBox, ReportLeftLayout, SectionLinkItem } from './index';
import ClientStatement from './client-statement';
import TransactionStatement from './transaction-statement';
import PortfolioSummary from './portfolio-summary';
import CGStatement from './cg-statement';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { CGStatIcon, PortfolioReportIcon, ReportsCGSDisabledIcon, ReportsClientStatementIcon, ReportsDetailedHoldingDisabledIcon, ReportsHoldingDisabledIcon, ReportsMFTxnIconDisabled, ReportsTxnHistoryDisabledIcon, ReportsTxnStatIcon, RMHoldingReportIcon } from '../../assets/SvgIcons';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { MFTransactionWiseHoldingReport } from '../dashboard/Reports_Dashboard/MF-Transactionwise-holding-report';
import { HoldingReport } from '../dashboard/Reports_Dashboard/holding-report';
import { DetailedHoldingReport } from '../dashboard/Reports_Dashboard/DetailedHoldingReport';

export default function InvestorReportRoute({
  location,
}: {
  location: Location<{ investorId: string; investorName: string }>;
}): JSX.Element {
  const theme = useTheme();
  const history = useHistory();
  const pathName = history.location.pathname;
  const { investorId, investorName } = location?.state || { investorId: '', investorName: '' };
  const [transitionClassName, setTransitionClassName] = useState('');
  const [isSideSectionDisabled, setSideSectionDisabled] = useState<boolean>(false)
  const { path } = useRouteMatch();

  //Dont change the routerLink it will affect functionality
  const leftMenuItem = [
    { title: 'Client Statement', routerLink: `client-statement` },
    { title: 'MF Transaction-wise Holding Report', routerLink: `mf-transaction-wise-holding-report` },
    { title: 'Holding Report', routerLink: `holding-report` },
    { title: 'Transaction Statement', routerLink: `transaction-statement` },
    { title: 'Portfolio Summary', routerLink: `portfolio-summary` },
    { title: 'Capital Gain Statement', routerLink: `cg-statement` },
    // { title: 'Detailed Holding Report', routerLink: `DetailedHoldingReport` },
  ];

  const links = [
    `${path}/client-statement`,
    `${path}/mf-transaction-wise-holding-report`,
    `${path}/holding-report`,
    `${path}/transaction-statement`,
    `${path}/portfolio-summary`,
    `${path}/cg-statement`,
    // `${path}/DetailedHoldingReport`
  ];


  const currentPath = pathName.split('/');
  const menuPath = leftMenuItem?.filter(item => item.routerLink === currentPath[2])[0]?.title;


  const [currentMenuItem, setCurrentMenuItem] = useState<string>(menuPath ? menuPath : 'Client Statement');
  const [openDrawer, setOpenDrawer] = useState<boolean>(false);

  const Menulinks = links.includes(pathName) ? links : [];
  const MenuItems = links.includes(pathName) ? leftMenuItem : [];

  const handleSideSectionDisabled = (value: boolean) => {
    setSideSectionDisabled(value)
  }


  const breadcrumbs = [

    <Link
      key="1"
      sx={{ cursor: 'pointer', textDecoration: 'none' }}
      onClick={() => history.push('/investors')}>
      Total Investors
    </Link>,
    <Typography key="2" color="text.primary">
      {investorName}
    </Typography>,
  ];
  return (
    <CommonLayoutForInvestor>
      <>
        {/* <Box
          sx={{
            background: '#EEF9F4',
            borderRadius: '16px',
            px: 3,
            py: 1.5,
            mb: 2.5,
          }}>
          <Breadcrumbs
            separator={<NavigateNextIcon fontSize="small" />}
            aria-label="breadcrumb"
            sx={{
              '& .MuiTypography-root': {
                fontSize: 20,
                lineHeight: '23px',
                fontWeight: 500,
                color: '#767676',
                '&.MuiTypography-body1': { color: '#22242C' },
              },
              '& .MuiBreadcrumbs-separator': {
                '& .MuiSvgIcon-root': { color: 'rgba(0,0,0,0.6)' },
                '&:last-of-type': {
                  background: 'red',
                  '& .MuiSvgIcon-root': { color: '#22242C' },
                },
              },
            }}>
            {breadcrumbs}
          </Breadcrumbs>
        </Box> */}

        <Box
          sx={{
            width: ['100%', '100%', '100%'],
            // ml: [0, 1, 1],
            // pt: [0, 0, 2],
            pt: [0, 0, 0],
            pb: [0, 0, '60px'],
            boxSizing: 'border-box',
          }}>
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="flex-end"
            sx={{ mb: "25px", display: ['none', 'flex', 'flex'] }}>
            <Typography
              variant='h1'
              sx={{
                color: 'text.primary',
                lineHeight: '32.5px'
              }}>
              Reports
            </Typography>
          </Stack>
          <Hidden smUp={true}>
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="flex-end"
              sx={{mb: "15px",display: {xs: 'flex', sm: 'none', md: 'none' }}}>
              <Typography
                variant='h1'
                sx={{
                  color: 'text.primary',
                  lineHeight: '32.5px'
                }}>
                Reports
              </Typography>
            </Stack>
            <Box
              sx={(theme: Theme) => (
                {
                  my: { xs: 2, sm: 3 },
                  p: { xs: "10px 12px", sm: '20px 18px' },
                  background: theme.palette.common.white,
                  borderRadius: '20px',
                  cursor: isSideSectionDisabled ? 'not-allowed' : 'pointer',
                  opacity: isSideSectionDisabled ? 0.5 : 1
                }
              )}
              onClick={() => {
                if (!isSideSectionDisabled) {
                  setOpenDrawer(true)
                }
              }}
            >
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                {/* <FormControl fullWidth >
                    <InputLabel shrink id="investor-items"></InputLabel>
                    <Select
                      labelId="investor-items"
                      value={MenuItems[Menulinks?.indexOf(pathName)]?.routerLink}
                      onChange={(e) => {
                        history.push(`${e.target.value}`, {
                          investorId: investorId,
                          investorName: investorName,
                        });
                      }}
                      sx={(theme: Theme) => (
                        {
                          borderRadius: '20px',
                          background: theme.palette.common.white,
                          fontWeight: '500',
                          fontSize: '16px',
                          color: theme.palette.primary[500],
                          letterSpacing: '0.02px',
                          lineHeight: '18px'
                        }
                      )}
                      IconComponent={(props) => {
                        console.log("PROP", props);

                        // <ArrowDropDownIcon
                        //   {...props}
                        //   sx={{
                        //     paddingRight: '13px',
                        //     color: '#00D9DA !important',
                        //     cursor: 'pointer',
                        //   }}
                        //   fontSize="large"
                        // />
                        return (

                          <ExpandMoreIcon
                            {...props}
                            sx={(theme: Theme) => (
                              {
                                paddingRight: '13px',
                                color: theme.palette.text.primary,
                                cursor: 'pointer',
                              }
                            )}
                            fontSize="large"
                          />
                        )
                      }}
                    >
                      {leftMenuItem.map((itemlist, ind) => (
                        <MenuItem

                          sx={(theme: Theme) => (
                            {
                              color: theme.palette.text.secondary,
                              fontWeight: 500,
                              fontSize: '16px'
                            }
                          )}
                          divider
                          value={itemlist.routerLink}
                          key={ind}>
                          {itemlist.title}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl> */}
                <Box sx={{ display: 'flex', alignItems: 'center', columnGap: '10px' }}>
                  {currentMenuItem === leftMenuItem[0]?.title && <ReportsClientStatementIcon />}
                  {currentMenuItem === leftMenuItem[1]?.title && <ReportsClientStatementIcon />}
                  {currentMenuItem === leftMenuItem[2]?.title && <RMHoldingReportIcon />}
                  {currentMenuItem === leftMenuItem[3]?.title && <ReportsTxnStatIcon />}
                  {currentMenuItem === leftMenuItem[4]?.title && <PortfolioReportIcon />}
                  {currentMenuItem === leftMenuItem[5]?.title && <CGStatIcon />}
                  <Typography variant='subtitle_500' sx={(theme: Theme) => ({
                    color: theme.palette.text.primary,
                    letterSpacing: '0.02px'
                  })}>{currentMenuItem}</Typography>
                </Box>
                <ExpandMoreIcon sx={{ color: theme.palette.text.primary }} />
              </Box>
            </Box>
          </Hidden>
          <Paper
            sx={{
              p: {xs:'15px',sm:'25px'},
              // backgroundColor: 'primary.light',
              // boxShadow: [0, 0, 24],
              // borderRadius: [0, 0, '10px'],
              // height: ['auto', 'auto', 'auto'],
              boxShadow: '0,0,0,rgba(0,0,0,0.05)',
              borderRadius: [0, 0, '25px'],
              height: ['auto', 'auto', 'auto'],
            }}>
            <Stack direction="row" sx={{ width: '100%' }}>
              <Hidden only="xs">
                <ReportLeftLayout>
                  <SectionLinkItem
                    to={{
                      pathname: `${path}/client-statement`,
                      state: {
                        investorId: investorId,
                        investorName: investorName,
                      },
                    }}
                    title={'Client Statement'}
                    icon={
                      // <CardMedia
                      //   component="img"
                      //   src="/images/client-statement.svg"
                      //   sx={{ width: 'unset', mx: 'auto' }}
                      // />
                      <ReportsMFTxnIconDisabled />
                    }
                    disabled={isSideSectionDisabled}
                  />
                  <SectionLinkItem
                    to={{
                      pathname: `${path}/transaction-statement`,
                      state: {
                        investorId: investorId,
                        investorName: investorName,
                      },
                    }}
                    title={'Transaction Statement'}
                    icon={
                      // <CardMedia
                      //   component="img"
                      //   src="/images/transaction-statement.svg"
                      //   sx={{ width: 'unset', mx: 'auto' }}
                      // />
                      <ReportsTxnHistoryDisabledIcon />
                    }
                    disabled={isSideSectionDisabled}
                  />
                  <SectionLinkItem
                    to={{
                      pathname: `${path}/mf-transaction-wise-holding-report`,

                    }}
                    title={'MF Transaction-wise Holding Report'}
                    icon={
                      <ReportsMFTxnIconDisabled />
                    }
                    disabled={isSideSectionDisabled}
                  />
                  <SectionLinkItem
                    to={{
                      pathname: `${path}/holding-report`,

                    }}
                    title={'Holding Report'}
                    icon={
                      <ReportsHoldingDisabledIcon />
                    }
                    disabled={isSideSectionDisabled}
                  />
                  {/* <SectionLinkItem
                    to={{
                      pathname: `${path}/portfolio-summary`,
                      state: {
                        investorId: investorId,
                        investorName: investorName,
                      },
                    }}
                    title={'Portfolio Summary'}
                    icon={
                      // <CardMedia
                      //   component="img"
                      //   src="/images/portfolio-summary.svg"
                      //   sx={{ width: 'unset', mx: 'auto' }}
                      // />
                      <ReportsCGSDisabledIcon />
                    }
                    disabled={isSideSectionDisabled}
                  /> */}
                  <SectionLinkItem
                    to={{
                      pathname: `${path}/cg-statement`,
                      state: {
                        investorId: investorId,
                        investorName: investorName,
                      },
                    }}
                    title={'Capital Gain Statement'}
                    icon={
                      // <CardMedia
                      //   component="img"
                      //   src="/images/cg-statement.svg"
                      //   sx={{ width: 'unset', mx: 'auto' }}
                      // />
                      <ReportsDetailedHoldingDisabledIcon />
                    }
                    disabled={isSideSectionDisabled}
                  />
                  {/* <SectionLinkItem
                    to={{
                      pathname: `${path}/DetailedHoldingReport`,

                    }}
                    title={'Detailed Holding Report'}
                    icon={
                      <ReportsDetailedHoldingDisabledIcon />
                    }
                    disabled={isSideSectionDisabled}
                  /> */}
                </ReportLeftLayout>
              </Hidden>
              {/* <Divider
                  orientation="vertical"
                  sx={{
                    borderWidth: '1px',
                    borderColor: 'text.dividerLight',
                    mr: 1,
                    ml: 2,
                    display: ['none', 'none', 'flex'],
                  }}
                  flexItem
                /> */}
              <AnimatedBox
                sx={{
                  minWidth: "200px",
                  flex: 2
                }}
                className={transitionClassName}
              >
                <Box sx=
                  {{
                    border: `1px solid ${theme.palette.text.secondary}26`,
                    padding: {xs:"15px",sm:"35px"},
                    borderRadius: '15px',
                  }}
                >
                  <Router history={history}>
                    <Switch>
                      <Redirect
                        exact
                        from={path}
                        to={{
                          pathname: `${path}/client-statement`,
                          state: { investorId, investorName },
                        }}
                      />
                      <Route
                        path={`${path}/client-statement`}
                        render={(props) => (

                          <ClientStatement
                            {...props}
                            // investorId={investorId}
                            // investorName={investorName}
                            location={location}
                            handleSideSectionDisabled={handleSideSectionDisabled}
                          />
                        )}
                      />
                      <Route
                        path={`${path}/mf-transaction-wise-holding-report`}
                        render={() => (
                          <MFTransactionWiseHoldingReport
                            handleSideSectionDisabled={handleSideSectionDisabled}
                          />
                        )}
                      />
                      <Route
                        path={`${path}/holding-report`}
                        render={() => (
                          <HoldingReport
                            handleSideSectionDisabled={handleSideSectionDisabled}
                          />
                        )}
                      />
                      <Route
                        path={`${path}/transaction-statement`}
                        render={(props) => (
                          <TransactionStatement
                            {...props}
                            // investorId={investorId}
                            // investorName={investorName}
                            location={location}
                            handleSideSectionDisabled={handleSideSectionDisabled}
                          />
                        )}
                      />
                      {/* <Route
                        path={`${path}/portfolio-summary`}
                        render={(props) => (
                          <PortfolioSummary
                            {...props}
                            // investorId={investorId}
                            // investorName={investorName}
                            location={location}
                            handleSideSectionDisabled={handleSideSectionDisabled}
                          />
                        )}
                      /> */}
                      <Route
                        path={`${path}/cg-statement`}
                        render={(props) => (
                          <CGStatement
                            {...props}
                            // investorId={investorId}
                            // investorName={investorName}
                            location={location}
                            handleSideSectionDisabled={handleSideSectionDisabled}
                          />
                        )}
                      />
                      {/* <Route
                        path={`${path}/DetailedHoldingReport`}
                        render={() => (
                          <DetailedHoldingReport
                            handleSideSectionDisabled={handleSideSectionDisabled}
                          />
                        )}
                      /> */}
                    </Switch>
                  </Router>
                </Box>
              </AnimatedBox>
            </Stack>
          </Paper>
        </Box>

        {/* Drawer */}
        <Drawer anchor='bottom' open={openDrawer} onClose={() => setOpenDrawer(false)}
          sx={{
            borderRadius: '25px 25px 0px 0px',
            ".MuiPaper-elevation": {
              borderRadius: '25px 25px 0px 0px',
              backgroundColor: theme.palette.background.paper
            }
          }}
        >
          {<DrawerList currentMenuItem={currentMenuItem} setCurrentMenuItem={setCurrentMenuItem} leftMenuItem={leftMenuItem} setOpenDrawer={setOpenDrawer} links={links} theme={theme} />}
        </Drawer>
      </>
    </CommonLayoutForInvestor>
  );
}


const DrawerList = ({ currentMenuItem, setCurrentMenuItem, leftMenuItem, setOpenDrawer, links, theme }: { currentMenuItem: string, setCurrentMenuItem: React.Dispatch<React.SetStateAction<string>>, leftMenuItem: any, setOpenDrawer: React.Dispatch<React.SetStateAction<boolean>>, links: any, theme: Theme }) => {
  const { path } = useRouteMatch();
  const history = useHistory();
  const handleClick = (index: number) => {
    setOpenDrawer(false)
    setCurrentMenuItem(leftMenuItem[index]?.title)
    history.push(links[index])
  }
  return (
    <List sx={{ padding: '10px 20px' }}>
      {leftMenuItem?.map((row: any, index: number) => (
        <ListItemButton key={index} onClick={() => handleClick(index)} sx={{ display: 'flex', alignItems: 'center', columnGap: '15px' }}>
          {index === 0 && <ReportsMFTxnIconDisabled />}
          {index === 1 && <ReportsTxnHistoryDisabledIcon />}
          {index === 2 && <ReportsCGSDisabledIcon />}
          {index === 3 && <ReportsDetailedHoldingDisabledIcon />}
          <ListItemText>
            {row?.title}
          </ListItemText>
        </ListItemButton>

      ))}
    </List>


  )
}
